export { default } from './HomeTab';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/index.ts